import { useEffect } from 'react';
import ThemeProvider from 'react-bootstrap/ThemeProvider';
import { useSelector } from 'react-redux';
import WSRayTeams from './components/socket/WSRayTeams';
import Root from './routes/root';
import "./sass/index.scss";
import RouteChangeTracker from "./components/RouteChangeTracker";

function App() {
  const theme = useSelector(state => state.AppReducer.theme);

  useEffect(() => {
    document.body.dataset.bsTheme = theme;
  }, [theme]);

  RouteChangeTracker();

  return <ThemeProvider>
    <Root />
    {/* <WSRayTeams /> */}
  </ThemeProvider>
}

export default App;
